/**
 * OrderUpdateBanner.jsx
 *
 * Real-time order update notification banner.
 * Appears at the top of the screen when an order status changes.
 * Auto-dismisses after 8 seconds.
 */

import { useOrderUpdates } from '../hooks/useOrderUpdates';
import { useTranslation } from 'react-i18next'

const EVENT_ICONS = {
  SAMPLE_PICKED_UP: '🚗',
  SAMPLE_DELIVERED_TO_LAB: '🏥',
  ORDER_COMPLETED: '✅',
  ORDER_CANCELLED: '❌',
};

const OrderUpdateBanner = () => {
  const { t } = useTranslation();
  const { latestUpdate, clearUpdate } = useOrderUpdates();

  if (!latestUpdate) return null;

  const icon = EVENT_ICONS[latestUpdate.event] || '📋';

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        backgroundColor: '#0d5d73',
        color: '#ffffff',
        borderRadius: 12,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        maxWidth: 480,
        width: '90%',
        animation: 'slideDown 0.3s ease',
      }}
    >
      <span style={{ fontSize: 24 }}>{icon}</span>
      <div style={{ flex: 1 }}>
        <p style={{ fontWeight: 700, fontSize: 14, margin: 0 }}>
          {t('checkout.order_number', { number: latestUpdate.orderNumber })}
        </p>
        <p style={{ fontSize: 13, margin: 0, opacity: 0.9 }}>
          {latestUpdate.message}
        </p>
      </div>
      <button
        onClick={clearUpdate}
        style={{
          background: 'none',
          border: 'none',
          color: '#ffffff',
          fontSize: 18,
          cursor: 'pointer',
          opacity: 0.8,
          padding: '0 4px',
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default OrderUpdateBanner;
